<template>
    <div class="product-means-detail">
        <!-- ==================== 顶部区域：导航操作 + 信息栏 ==================== -->
        <div class="top">
            <!-- 顶部操作栏：翻页按钮 + 功能按钮 -->
            <div class="top_operate">
                <!-- 翻页导航：上一条/下一条 -->
                <div class="nav-arrows">
                    <img
                        src="../../../screenshots/last1.png"
                        class="nav-arrow-icon"
                        :class="{ 'nav-arrow-disabled': !last }"
                        alt=""
                        @click="!isEdit ? '' : changeOrder(1)"
                    />
                    <img
                        src="../../../screenshots/next1.png"
                        class="nav-arrow-icon nav-arrow-icon--reverse"
                        :class="{ 'nav-arrow-disabled': !last }"
                        alt=""
                        @click="!isEdit ? '' : changeOrder(2)"
                    />
                    <img
                        src="../../../screenshots/next1.png"
                        class="nav-arrow-icon"
                        :class="{ 'nav-arrow-disabled': !first }"
                        alt=""
                        @click="!isEdit ? '' : changeOrder(3)"
                    />
                    <img
                        src="../../../screenshots/last1.png"
                        class="nav-arrow-icon nav-arrow-icon--reverse"
                        :class="{ 'nav-arrow-disabled': !first }"
                        alt=""
                        @click="!isEdit ? '' : changeOrder(4)"
                    />
                </div>
                <!-- 功能操作按钮组 -->
                <div class="action-buttons">
                    <el-button type="success" plain @click="labelClick()" v-if="perData.allow_print == 1">标签打印</el-button>
                    <el-button
                        type="warning"
                        size="mini"
                        icon="el-icon-edit"
                        @click="edit"
                        :disabled="!isEdit || isCheck"
                        v-if="perData.allow_edit == 1"
                    >{{ $t('common.edit') }}</el-button>
                    <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        :disabled="!isEdit || isCheck"
                        @click="deleteIt"
                        v-if="perData.allow_dele == 1"
                    >{{ $t('common.delete') }}</el-button>
                    <el-button
                        type="success"
                        size="mini"
                        icon="el-icon-document-checked"
                        :disabled="isEdit"
                        @click="saveIt"
                    >{{ $t('common.save') }}</el-button>
                    <el-button
                        type="info"
                        size="mini"
                        icon="el-icon-refresh-left"
                        :disabled="isEdit"
                        @click="refreshData(form.salesj_no)"
                    >撤回</el-button>
                    <el-button
                        type="primary"
                        :disabled="!isEdit || isAdd"
                        plain
                        @click="check()"
                        v-if="perData.allow_check == 1"
                    >{{ form.check == 1 ? $t('common.cancelAudit') : $t('common.audit') }}</el-button>
                </div>
            </div>

            <!-- 信息展示栏：创建人/修改人/时间/审核状态 -->
            <div class="top_col">
                <el-row :gutter="20">
                    <el-col :span="3">
                        <div class="info-item">
                            <span class="info-label">{{ $t('common.creator') }}</span>
                            <span class="info-value">{{ form.build_no }}</span>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <div class="info-item">
                            <span class="info-label">{{ $t('common.modifier') }}</span>
                            <span class="info-value">{{ form.modify_no }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="info-item">
                            <span class="info-label">{{ $t('common.createTime') }}</span>
                            <span class="info-value">{{ form.build_date }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="info-item">
                            <span class="info-label">{{ $t('common.modifyTime') }}</span>
                            <span class="info-value">{{ form.modify_date }}</span>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <div class="info-item">
                            <span class="info-label">{{ $t('common.auditor') }}</span>
                            <span class="info-value">{{ form.check_no }}</span>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <div class="info-item">
                            <span class="info-label">{{ $t('common.auditStatus') }}</span>
                            <span :class="form.check == 1 ? 'audit-badge audit-badge--pass' : 'audit-badge audit-badge--fail'">
                                {{ form.check == 1 ? $t('common.audited') : $t('common.notAudited') }}
                            </span>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!-- ==================== 主体区域：表单 + 图片附件 ==================== -->
        <div class="edit_warpper">
            <!-- 左侧：产品详情表单 -->
            <div class="form-section">
                <el-form :model="form" label-width="130px" ref="form" :rules="rules">
                    <!-- ====== 基本信息 ====== -->
                    <el-form-item label="产品编号" prop="style_no">
                        <el-input placeholder="请输入产品编号" v-model="form.style_no" :disabled="isEdit || !isAdd"></el-input>
                    </el-form-item>
                    <el-form-item label="产品名称：" prop="style_name">
                        <el-input placeholder="请输入产品名称" v-model="form.style_name" :disabled="isEdit"></el-input>
                    </el-form-item>
                    <el-form-item label="产品别名：">
                        <el-input placeholder="请输入产品别名" v-model="form.style_ename" :disabled="isEdit"></el-input>
                    </el-form-item>
                    <el-form-item label="是否启用：">
                        <el-switch v-model="form.status" :disabled="isEdit" style="margin-left: 5px" active-value="1" inactive-value="0"></el-switch>
                    </el-form-item>

                    <!-- ====== 品类品目 ====== -->
                    <el-form-item label="品类：" prop="type_no">
                        <mySelect
                            placeholders="请选择品类"
                            v-model="form.type_no"
                            :options="pullData.type"
                            class="select"
                            values="kind_no"
                            labels="kind_name"
                            keys="kind_no"
                            :disable="isEdit"
                        ></mySelect>
                    </el-form-item>
                    <el-form-item label="品目：" prop="kind_no">
                        <mySelect
                            placeholders="请选择品目"
                            v-model="form.kind_no"
                            :options="pullData.kind"
                            class="select"
                            values="kind_no"
                            labels="kind_name"
                            keys="kind_no"
                            :disable="isEdit"
                        ></mySelect>
                    </el-form-item>
                    <el-form-item label="金成色：" prop="gold_name">
                        <mySelect
                            placeholders="请选择金成色"
                            v-model="form.gold_no"
                            :options="pullData.gold"
                            class="select"
                            values="kind_no"
                            labels="kind_name"
                            keys="kind_no"
                            :disable="isEdit"
                        ></mySelect>
                    </el-form-item>

                    <!-- ====== 成色与折扣 ====== -->
                    <el-form-item label="折扣：">
                        <el-input placeholder="请输入折扣" v-model="form.discount" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="单件重：">
                        <el-input placeholder="请输入单件重" v-model="form.unit_wgt" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库含耗率：">
                        <el-input placeholder="请输入含耗率" v-model="form.incontainloss_rate" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库含耗率：">
                        <el-input placeholder="请输入含耗率" v-model="form.salecontainloss_rate" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="成色：">
                        <el-input placeholder="请输入成色" v-model="form.ratio" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库成色：">
                        <el-input placeholder="请输入出库成色" v-model="form.outratio" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <!-- ====== 绑定关联 ====== -->
                    <el-form-item label="绑定柜台：">
                        <mySelect
                            placeholders="请选择柜台"
                            v-model="form.counter_no"
                            :options="pullData.counter"
                            class="select"
                            values="kind_no"
                            labels="kind_name"
                            keys="kind_no"
                            :disable="isEdit"
                        ></mySelect>
                    </el-form-item>
                    <el-form-item label="绑定客户：">
                        <mySelect
                            placeholders="请选择客户"
                            v-model="form.cust_no"
                            :options="pullData.cust"
                            class="select"
                            values="kind_no"
                            labels="kind_name"
                            keys="kind_no"
                            :disable="isEdit"
                        ></mySelect>
                    </el-form-item>

                    <!-- ====== 结价/结料产品 ====== -->
                    <el-form-item label="结价产品：">
                        <mySelect
                            placeholders="请选择结价产品"
                            v-model="form.balprc_style_no"
                            :options="pullData.stylesec"
                            class="select"
                            values="kind_no"
                            labels="kind_name"
                            keys="kind_no"
                            :disable="isEdit"
                        ></mySelect>
                    </el-form-item>
                    <el-form-item label="结料产品：">
                        <mySelect
                            placeholders="请选择结料产品"
                            v-model="form.tran_style_no"
                            :options="pullData.stylesec"
                            class="select"
                            values="kind_no"
                            labels="kind_name"
                            keys="kind_no"
                            :disable="isEdit"
                        ></mySelect>
                    </el-form-item>

                    <!-- ====== 粗金属管理（系统配置开启时显示） ====== -->
                    <template v-if="systemSet.isCoarseMetaManage == 1">
                        <el-form-item label="金属1：">
                            <mySelect placeholders="请选择" v-model="form.style1_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit"></mySelect>
                        </el-form-item>
                        <el-form-item label="金属2：">
                            <mySelect placeholders="请选择" v-model="form.style2_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit"></mySelect>
                        </el-form-item>
                        <el-form-item label="金属3：">
                            <mySelect placeholders="请选择" v-model="form.style3_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit"></mySelect>
                        </el-form-item>
                        <el-form-item label="金属4：">
                            <mySelect placeholders="请选择" v-model="form.style4_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit"></mySelect>
                        </el-form-item>
                        <el-form-item label="金属5：">
                            <mySelect placeholders="请选择" v-model="form.style5_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit"></mySelect>
                        </el-form-item>
                    </template>

                    <!-- ====== 金银料管理（系统配置开启时显示） ====== -->
                    <template v-if="systemSet.isgoldsilver == 1">
                        <el-form-item label="金料：">
                            <mySelect placeholders="请选择" v-model="form.gold_style_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit" :myChange="changeGold(form.gold_style_no)"></mySelect>
                        </el-form-item>
                        <el-form-item label="金料结价产品：">
                            <mySelect placeholders="请选择" v-model="form.balprc_gold_style_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit"></mySelect>
                        </el-form-item>
                        <el-form-item label="金料结料产品：">
                            <mySelect placeholders="请选择" v-model="form.tran_gold_style_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit"></mySelect>
                        </el-form-item>
                        <el-form-item label="银料：">
                            <mySelect placeholders="请选择" v-model="form.silver_style_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit" :myChange="changesilver(form.silver_style_no)"></mySelect>
                        </el-form-item>
                        <el-form-item label="银料结价产品：">
                            <mySelect placeholders="请选择" v-model="form.balprc_silver_style_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit"></mySelect>
                        </el-form-item>
                        <el-form-item label="银料结料产品：">
                            <mySelect placeholders="请选择" v-model="form.tran_silver_style_no" :options="pullData.stylesec" class="select" values="kind_no" labels="kind_name" keys="kind_no" :disable="isEdit"></mySelect>
                        </el-form-item>
                    </template>

                    <!-- ====== 入库价格设置 ====== -->
                    <div class="section-divider">
                        入库价格设置
                    </div>
                    <el-form-item label="入库数单价：">
                        <el-input placeholder="请输入入库数单价" v-model="form.inqty_prc" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库数单价倍率：">
                        <el-input placeholder="请输入入库数单价倍率" v-model="form.inqty_prc_multiplier" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库数单价1：">
                        <el-input placeholder="请输入入库数单价" v-model="form.inqty_prc1" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库数单价2：">
                        <el-input placeholder="请输入入库数单价" v-model="form.inqty_prc2" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库数单价3：">
                        <el-input placeholder="请输入入库数单价" v-model="form.inqty_prc3" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库重单价：">
                        <el-input placeholder="请输入入库重单价" v-model="form.inwgt_prc" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库重单价1：">
                        <el-input placeholder="请输入入库重单价1" v-model="form.inwgt_prc1" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库重单价2：">
                        <el-input placeholder="请输入入库重单价2" v-model="form.inwgt_prc2" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库重单价3：">
                        <el-input placeholder="请输入入库重单价3" v-model="form.inwgt_pr3c" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库附加费(数)：">
                        <el-input placeholder="请输入入库附加费（数）" v-model="form.inadd_qtywage" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库附加费(重)：">
                        <el-input placeholder="请输入入库附加费（重）" v-model="form.inadd_wgtwage" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库附加费：">
                        <el-input placeholder="请输入入库附加费" v-model="form.inadd_wage" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>

                    <!-- ====== 出库价格设置 ====== -->
                    <div class="section-divider">
                        出库价格设置
                    </div>
                    <el-form-item label="出库数单价：">
                        <el-input placeholder="请输入出库数单价" v-model="form.saleqty_prc" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库数单价倍率：">
                        <el-input placeholder="请输入出库数单价倍率" v-model="form.saleqty_prc_multiplier" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库数单价1：">
                        <el-input placeholder="请输入出库数单价1" v-model="form.saleqty_prc1" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库数单价2：">
                        <el-input placeholder="请输入出库数单价2" v-model="form.saleqty_prc2" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库数单价3：">
                        <el-input placeholder="请输入出库数单价3" v-model="form.saleqty_prc3" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库重单价：">
                        <el-input placeholder="请输入出库重单价" v-model="form.salewgt_prc" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库重单价1：">
                        <el-input placeholder="请输入出库重单价1" v-model="form.salewgt_prc1" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库重单价2：">
                        <el-input placeholder="请输入出库重单价2" v-model="form.salewgt_prc2" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库重单价3：">
                        <el-input placeholder="请输入出库重单价3" v-model="form.salewgt_prc3" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库附加费(数)：">
                        <el-input placeholder="请输入出库附加费（数）" v-model="form.saleadd_qtywage" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库附加费(重)：">
                        <el-input placeholder="请输入出库附加费（重）" v-model="form.saleadd_wgtwage" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="出库附加费：">
                        <el-input placeholder="请输入出库附加费" v-model="form.saleadd_wage" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>

                    <!-- ====== 库存上下限 ====== -->
                    <div class="section-divider">
                        库存上下限
                    </div>
                    <el-form-item label="最高库存(重)：">
                        <el-input placeholder="请输入最高库存（重）" v-model="form.max_wgt" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="最高库存(数)：">
                        <el-input placeholder="请输入最高库存（数）" v-model="form.max_qty" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="最低库存(重)：">
                        <el-input placeholder="请输入最低库存（重）" v-model="form.min_wgt" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="最低库存(数)：">
                        <el-input placeholder="请输入最低库存（数）" v-model="form.min_qty" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>

                    <!-- ====== 最低出库价 ====== -->
                    <el-form-item label="最低出库数单价：">
                        <el-input placeholder="最低出库数单价" v-model="form.saleqty_prc_lower" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="最低出库重单价：">
                        <el-input placeholder="最低出库重单价" v-model="form.salewgt_prc_lower" :disabled="isEdit" type="number"></el-input>
                    </el-form-item>

                    <!-- ====== 备注（独占一行） ====== -->
                    <div class="form-remark-row">
                        <el-form-item :label="$t('common.remark') + '：'">
                            <el-input
                                placeholder="请输入备注"
                                type="textarea"
                                :rows="2"
                                v-model="form.remark"
                                class="remark-textarea"
                                :disabled="isEdit"
                            ></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>

            <!-- 右侧：图片附件 + BOM清单 -->
            <div class="right-section">
                <!-- 图片附件上传区域 -->
                <div class="img_warpper">
                <p class="img-upload-title">
                    图片附件
                    <span>（支持.png .jpg .jpeg .gif的图片类型，最多上传4张，建议单张图片不超过5M）</span>
                </p>
                <div class="img-list-container">
                    <!-- 已上传图片列表 -->
                    <ul v-for="item in fileList" :key="item" class="el-upload-list el-upload-list--picture-card">
                        <li tabindex="0" class="el-upload-list__item is-success">
                            <img :src="item" alt="产品图片" class="el-upload-list__item-thumbnail" />
                            <a class="el-upload-list__item-name"><i class="el-icon-document"></i></a>
                            <label class="el-upload-list__item-status-label">
                                <i class="el-icon-upload-success el-icon-check"></i>
                            </label>
                            <i class="el-icon-close"></i>
                            <i class="el-icon-close-tip">按 delete 键可删除</i>
                            <span class="el-upload-list__item-actions">
                                <span @click="handlePictureCardPreview(item)" class="el-upload-list__item-preview">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="!isEdit" class="el-upload-list__item-delete" @click="beforeRemove(item, fileList)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </li>
                    </ul>
                    <!-- 上传按钮（非编辑状态且未满4张时显示） -->
                    <el-upload
                        list-type="picture-card"
                        :action="uploadAction"
                        :data="uploadData"
                        :headers="headers"
                        :before-remove="beforeRemove"
                        :on-preview="handlePictureCardPreview"
                        :on-success="success"
                        :on-error="uploadError"
                        :before-upload="beforeUpload"
                        ref="upload"
                        :show-file-list="false"
                        v-if="!isEdit"
                        :disabled="fileList.length >= 4 || uploading"
                    >
                        <i class="el-icon-plus" v-if="!uploading"></i>
                        <i class="el-icon-loading" v-else></i>
                    </el-upload>
                    <!-- 上传中遮罩层 -->
                    <div class="upload-overlay" v-if="uploading">
                        <i class="el-icon-loading"></i>
                        <span>图片上传中...</span>
                    </div>
                    <!-- 图片预览弹窗 -->
                    <el-dialog width="50%" class="img-preview-dialog" :close-on-click-modal="false" :visible.sync="dialogVisibleImg">
                        <img style="max-width: 100%; max-height: 100%" :src="dialogImageUrl" alt="图片预览" />
                    </el-dialog>
                </div>
            </div>

            <!-- BOM清单表格 -->
            <div class="bom-section">
                <div class="bom-header">
                    <span class="bom-title">BOM清单</span>
                    <el-button v-if="!isEdit" type="primary" size="mini" icon="el-icon-plus" @click="addBomRow">添加行</el-button>
                </div>
                <el-table :data="form.bom || []" border size="small" class="bom-table">
                    <el-table-column label="序号" width="60" align="center">
                        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                    </el-table-column>
                    <el-table-column label="产品" min-width="160">
                        <template slot-scope="scope">
                            <el-select
                                v-model="scope.row.style_no"
                                filterable
                                placeholder="请选择产品"
                                :disabled="isEdit"
                                size="small"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in pullData.stylesec"
                                    :key="item.kind_no"
                                    :label="item.kind_no + '-' + item.kind_name"
                                    :value="item.kind_no"
                                ></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" width="80">
                        <template slot-scope="scope">
                            <el-input-number
                                v-model="scope.row.qty"
                                :disabled="isEdit"
                                :controls="false"
                                size="small"
                                style="width: 100%"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="重量" width="100">
                        <template slot-scope="scope">
                            <el-input-number
                                v-model="scope.row.wgt"
                                :disabled="isEdit"
                                :controls="false"
                                :precision="4"
                                size="small"
                                style="width: 100%"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="规格" min-width="100">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.spec" :disabled="isEdit" size="small" placeholder="规格"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="形状" min-width="100">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.shape" :disabled="isEdit" size="small" placeholder="形状"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="颜色" min-width="100">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.color" :disabled="isEdit" size="small" placeholder="颜色"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" min-width="120">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark" :disabled="isEdit" size="small" placeholder="备注"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="60" align="center" v-if="!isEdit">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" icon="el-icon-delete" style="color: #f56c6c" @click="removeBomRow(scope.$index)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 产品资料详情页面
 * 功能：产品资料的新增、编辑、删除、审核、撤回、标签打印、图片上传
 * 依赖：Element UI 表单/上传组件、自定义 mySelect 下拉组件
 */
import {
    styleDateils,
    styleCheck,
    stylePull,
    styleAdd,
    styleUpdate,
    styleQuitIndex,
    styleDel,
    apiSetVipstoredel,
    styleprintLabelStylesec,
    apiCurrentPermisson
} from '@/request/api';

export default {
    name: 'ProductMeansDetail',

    data() {
        return {
            // ====== 页面状态控制 ======
            isEdit: true,       // 是否处于查看模式（true=查看，false=编辑）
            isCheck: false,     // 当前记录是否已审核
            isAdd: false,       // 是否为新增模式
            first: true,        // 是否有上一条记录
            last: true,         // 是否有下一条记录

            // ====== 表单数据 ======
            form: {},

            // ====== 图片上传相关 ======
            fileList: [],           // 已上传图片URL列表
            uploading: false,       // 是否正在上传图片
            blockedFiles: new Set(), // 被阻止上传的文件记录
            uploadAction: '',       // 上传接口地址
            uploadData: { url: 'style' }, // 上传附加参数
            headers: {},            // 上传请求头（含鉴权）
            dialogVisibleImg: false, // 图片预览弹窗是否显示
            dialogImageUrl: '',     // 当前预览的图片URL

            // ====== 表单校验规则 ======
            rules: {
                style_no: [{ required: true, message: '请输入产品编号', trigger: 'blur' }],
                style_name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
                type_no: [{ required: true, message: '请选择品类', trigger: 'blur' }],
                kind_no: [{ required: true, message: '请选择名目', trigger: 'blur' }],
                gold_no: [{ required: true, message: '请选择产品编号', trigger: 'blur' }]
            },

            // ====== 下拉选项数据 ======
            pullData: {},

            // ====== 系统配置（从localStorage读取） ======
            systemSet: JSON.parse(localStorage.getItem('systemSet')),

            // ====== 按钮权限数据 ======
            perData: {}
        };
    },

    /**
     * 生命周期 - 挂载
     * 初始化上传配置、判断新增/编辑模式、加载下拉数据和权限
     */
    mounted() {
        this._initUploadConfig();
        this._initPageMode();
        this.getPull();
        this.getPermission();
    },

    /**
     * 生命周期 - keep-alive 缓存组件激活时重新初始化页面
     * 解决从详情页返回列表后再点击新建，表单数据未清空的问题
     */
    activated() {
        this._initPageMode();
    },

    methods: {
        // ==================== 初始化相关 ====================

        /**
         * 初始化上传配置（接口地址、鉴权头）
         * @private
         */
        _initUploadConfig() {
            this.uploadAction = this.$baseURL + 'uploadOss_img';
            const token = sessionStorage.getItem('userToken');
            this.headers.Authorization = 'Bearer ' + token;
        },

        /**
         * 初始化页面模式（新增 or 编辑）
         * @private
         */
        _initPageMode() {
            this.isAdd = this.$route.query.isadd || false;
            if (this.isAdd) {
                // 新增模式：清空表单，进入编辑状态
                this.isEdit = false;
                this.form = {};
                this.fileList = [];
            } else {
                // 编辑模式：加载详情数据
                this.searchIt();
            }
        },

        // ==================== BOM清单管理 ====================

        /**
         * 添加BOM行
         */
        addBomRow() {
            if (!this.form.bom) {
                this.$set(this.form, 'bom', []);
            }
            this.form.bom.push({ style_no: '', qty: '', wgt: '', remark: '' });
        },

        /**
         * 删除BOM行
         * @param {number} index - 行索引
         */
        removeBomRow(index) {
            this.form.bom.splice(index, 1);
        },

        // ==================== 数据获取 ====================

        /**
         * 获取下拉选项数据（品类、品目、金成色、柜台、客户等）
         */
        getPull() {
            stylePull().then((res) => {
                this.pullData = res.data;
            });
        },

        /**
         * 获取当前页面按钮权限（添加、修改、删除、审核、打印）
         */
        getPermission() {
            apiCurrentPermisson({ id: '121' }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        /**
         * 根据路由参数中的ID加载产品详情
         */
        searchIt() {
            this.$load.show();
            const id = this.$route.query.detailid;
            styleDateils({ id }).then((res) => {
                this.$load.close();
                this._setFormData(res);
            });
        },

        /**
         * 根据当前form中的id重新获取数据（用于编辑/审核后刷新）
         */
        getData() {
            this.$load.show();
            styleDateils({ id: this.form.id }).then((res) => {
                this.$load.close();
                this._setFormData(res);
            });
        },

        /**
         * 统一设置表单数据（从接口响应中提取）
         * @param {Object} res - 接口返回的响应对象
         * @private
         */
        _setFormData(res) {
            this.form = res.data;
            this.fileList = res.data.imgs;
            this.first = res.ag.first;
            this.last = res.ag.last;
            this.isCheck = res.data.check == 1;
        },

        // ==================== 翻页导航 ====================

        /**
         * 切换记录（上/下翻页）
         * @param {number} type - 翻页方向：1=上一条, 2=下一条, 3=后一条, 4=前一条
         */
        changeOrder(type) {
            this.$load.show();
            styleQuitIndex({ id: this.form.id, type }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this._setFormData(res);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        // ==================== CRUD 操作 ====================

        /**
         * 进入编辑模式
         */
        edit() {
            this.isEdit = false;
            this.isAdd = false;
        },

        /**
         * 删除当前产品
         * 删除成功后自动跳转到下一条记录
         */
        deleteIt() {
            this.$confirm('确定要删除该产品资料吗？', '提示', { type: 'warning' }).then(() => {
                styleDel({ id: this.form.id }).then((res) => {
                    if (res.code == 2000) {
                        this.$message.success('删除成功');
                        this.changeOrder(4); // 删除后跳转到前一条
                    } else {
                        this.$message.error('删除失败');
                    }
                });
            });
        },

        /**
         * 保存表单（新增 or 修改）
         * 保存前进行格式校验：产品名不含空格、编号不含中文和空格
         */
        saveIt() {
            // 校验产品名称不含空格
            const noSpacePattern = /^[^\s]*$/;
            if (!noSpacePattern.test(this.form.style_name)) {
                this.$message.error('产品名称不能含有空格');
                return;
            }
            // 校验产品编号不含中文和空格
            const noChinesePattern = /^[^\u4e00-\u9fa5]+$/;
            if (!noChinesePattern.test(this.form.style_no) || !noSpacePattern.test(this.form.style_no)) {
                this.$message.error('产品编号不能包含中文字符或者空格');
                return;
            }
            // 表单校验通过后执行保存
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this._doSave();
                } else {
                    return false;
                }
            });
        },

        /**
         * 执行保存请求（区分新增和修改）
         * @private
         */
        _doSave() {
            // 将图片数组转为逗号分隔字符串
            this.form.img = this.fileList.length > 0 ? this.fileList.join(',') : '';
            // BOM清单数据（确保传递数组）
            this.form.bom = this.form.bom || [];

            if (this.isAdd) {
                // 新增
                styleAdd({ ...this.form }).then((res) => {
                    if (res.code == 2000) {
                        this.$message.success('添加成功');
                        this.$router.push('/productMeans');
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            } else {
                // 修改
                styleUpdate({ ...this.form }).then((res) => {
                    if (res.code == 2000) {
                        this.$message.success('修改成功');
                        this.isEdit = true;
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
        },

        /**
         * 撤回（取消编辑，恢复查看模式并重新加载数据）
         */
        refreshData() {
            this.isEdit = true;
            this.getData();
        },

        /**
         * 审核/取消审核
         * 根据当前审核状态切换：已审核→取消审核，未审核→审核
         */
        check() {
            const check = this.form.check == 0 ? 1 : 0;
            styleCheck({ id: this.form.id, check }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                    this.getData();
                } else {
                    this.$message.error(res.data);
                }
            });
        },

        // ==================== 标签打印 ====================

        /**
         * 标签打印：获取打印URL后跳转到打印融合页面
         */
        labelClick() {
            styleprintLabelStylesec({ id: this.form.id }).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({ path: '/printingfusion', query: { url: res.data.Url } });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        // ==================== 金银料联动 ====================

        /**
         * 金料选择联动：自动同步金料结价产品和结料产品
         * @param {string} e - 选中的金料编号
         */
        changeGold(e) {
            this.form.balprc_gold_style_no = e;
            this.form.tran_gold_style_no = e;
        },

        /**
         * 银料选择联动：自动同步银料结价产品和结料产品
         * @param {string} e - 选中的银料编号
         */
        changesilver(e) {
            this.form.balprc_silver_style_no = e;
            this.form.tran_silver_style_no = e;
        },

        // ==================== 图片上传管理 ====================

        /**
         * 上传成功回调：将新图片添加到列表（去重）
         * @param {Object} file - 上传成功后的响应数据
         */
        success(file) {
            this.uploading = false;
            const imgUrl = file.data.imgs;
            const idx = this.fileList.findIndex((item) => item === imgUrl);
            if (idx === -1) {
                this.fileList.push(imgUrl);
            } else {
                this.$message.warning('该图片已经上传过了');
            }
        },

        /**
         * 上传失败回调：关闭加载状态
         */
        uploadError() {
            this.uploading = false;
            this.$message.error('图片上传失败，请重试');
        },

        /**
         * 上传前校验：限制文件数量（最多4张）和大小（单张≤5MB）
         * @param {File} file - 待上传的文件对象
         * @returns {boolean} 是否允许上传
         */
        beforeUpload(file) {
            if (this.fileList.length >= 4) {
                this.$message.warning('当前限制选择 4 个文件');
                return false;
            }
            const isUnder5MB = file.size / 1024 / 1024 < 5;
            if (!isUnder5MB) {
                this.$message.warning('上传图片大小不能超过 5MB!');
                return false;
            }
            // 开启上传中状态
            this.uploading = true;
            return true;
        },

        /**
         * 删除图片：调用后端接口清理远程文件，并从本地列表移除
         * @param {string} file - 待删除的图片URL
         */
        beforeRemove(file) {
            apiSetVipstoredel({ filePath: file }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                } else {
                    this.$message.error(res.msg);
                }
            });
            this.fileList = this.fileList.filter((item) => item != file);
        },

        /**
         * 图片预览：打开弹窗显示大图
         * @param {string} file - 图片URL
         */
        handlePictureCardPreview(file) {
            this.dialogVisibleImg = true;
            this.dialogImageUrl = file;
        },

        /**
         * 超出文件数量限制时的提示（预留，当前未绑定到el-upload的on-exceed）
         * @param {Array} files - 本次选择的文件
         * @param {Array} fileList - 当前已有文件列表
         */
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
            );
        }
    }
};
</script>

<style scoped lang="scss">
/* ==================== 全局/通用样式 ==================== */

/* 图片上传列表宽度自适应 */
/deep/ .el-upload-list {
    width: fit-content;
}

/* 页面整体背景 */
.product-means-detail {
    padding: 0 4px;
}

/* ==================== 翻页箭头图标 ==================== */

.nav-arrows {
    display: flex;
    align-items: center;
}

.nav-arrow-icon {
    width: 30px;
    cursor: pointer;
}

.nav-arrow-icon:not(:first-child) {
    margin-left: 15px;
}

.nav-arrow-icon--reverse {
    transform: rotate(180deg);
}

.nav-arrow-disabled {
    filter: grayscale(100%);
    opacity: 0.4;
    cursor: not-allowed;
}

/* ==================== 顶部区域 ==================== */

.top {
    width: 100%;
}

/* 顶部操作栏：白色卡片 + 微阴影 */
.top_operate {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 8px;
    padding: 12px 16px;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.06);
    border: 1px solid #e8f0fe;
    box-sizing: border-box;
}

/* 功能按钮组间距 */
.action-buttons {
    /deep/ .el-button + .el-button {
        margin-left: 10px;
    }
}

/* 信息展示栏：渐变背景卡片 */
.top_col {
    font-size: 13px;
    color: #666;
    margin: 12px 0;
    padding: 14px 20px;
    box-sizing: border-box;
    background: linear-gradient(135deg, #f8fbff 0%, #fff 100%);
    border: 1px solid #e8f0fe;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.06);
}

/* 信息项：标签 + 值 */
.info-item {
    display: flex;
    align-items: center;
    gap: 6px;
    line-height: 28px;
}

.info-label {
    color: #909399;
    font-size: 13px;
    white-space: nowrap;

    &::after {
        content: '：';
    }
}

.info-value {
    color: #303133;
    font-weight: 500;
    font-size: 13px;
}

/* 审核状态徽章 */
.audit-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
}

.audit-badge--pass {
    background: linear-gradient(135deg, #e1f3d8, #f0f9eb);
    color: #67c23a;
    border: 1px solid #c2e7b0;
}

.audit-badge--fail {
    background: linear-gradient(135deg, #fef0f0, #fde2e2);
    color: #f56c6c;
    border: 1px solid #fbc4c4;
}

/* ==================== 主体区域（表单 + 图片） ==================== */

.edit_warpper {
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    padding: 24px 16px 40px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #e8f0fe;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.06);
    gap: 20px;
}

/* ------ 左侧表单区域 ------ */
.form-section {
    flex: 2;

    .el-form {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .el-form-item {
        font-size: 14px;
        color: #131414;
        display: flex;
        margin-right: 40px;
        margin-bottom: 18px;
        transition: background-color 0.2s;
        border-radius: 4px;

        &:hover {
            background-color: rgba(64, 158, 255, 0.02);
        }

        /deep/ .el-form-item__label {
            color: #606266;
            font-weight: 500;
        }

        /deep/ .el-form-item__content {
            margin-left: 0 !important;
            width: 200px;
        }

        /* 禁用状态输入框背景 */
        /deep/ .el-input.is-disabled .el-input__inner {
            background-color: #f8f9fa;
            border-color: #ebeef5;
            color: #909399;
        }
    }
}

/* 分区标题：标签卡片风格 */
.section-divider {
    width: 100%;
    padding: 10px 16px;
    margin: 8px 0 16px;
    font-size: 14px;
    font-weight: 600;
    color: #409eff;
    background: linear-gradient(135deg, #ecf5ff 0%, #f5f9ff 100%);
    border-radius: 6px;
    border-left: 4px solid #409eff;
    box-shadow: 0 1px 4px rgba(64, 158, 255, 0.08);
}

/* 备注行独占一行 */
.form-remark-row {
    width: 100%;
    margin-top: 4px;
    padding-top: 12px;
    border-top: 1px dashed #e8f0fe;

    /deep/ .el-form-item__content {
        width: 100% !important;
        margin-right: 40px;
    }
}

/* 备注文本框宽度 */
.remark-textarea {
    width: 100%;
}

/* ------ 右侧区域（图片 + BOM） ------ */
.right-section {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.img_warpper {
    background: linear-gradient(135deg, #f8fbff 0%, #fff 100%);
    border: 1px solid #e8f0fe;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.06);
    box-sizing: border-box;
    position: relative;
}

/* 图片上传区域标题 */
.img-upload-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ecf5ff;

    span {
        color: #909399;
        font-weight: 400;
        font-size: 12px;
    }
}

/* 图片列表容器 */
.img-list-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

/* 图片预览弹窗居中 */
/deep/ .img-preview-dialog {
    text-align: center;
}

/* 上传中遮罩层 */
.upload-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    z-index: 10;
    pointer-events: all;

    i {
        font-size: 32px;
        color: #409eff;
        animation: rotating 1.5s linear infinite;
    }

    span {
        font-size: 14px;
        color: #606266;
        font-weight: 500;
    }
}

@keyframes rotating {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* ------ BOM清单区域 ------ */
.bom-section {
    background: linear-gradient(135deg, #f8fbff 0%, #fff 100%);
    border: 1px solid #e8f0fe;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.06);
}

.bom-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ecf5ff;
}

.bom-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

/* BOM表格样式 */
.bom-table {
    /deep/ .el-table__header th {
        background-color: #f5f7fa;
        color: #606266;
        font-weight: 600;
        padding: 8px 0;
    }

    /deep/ .el-table__body td {
        padding: 6px 0;
    }

    /deep/ .el-input-number .el-input__inner {
        text-align: right;
    }
}
</style>
